var _rect, _rect2, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.48535,
    y: 7.6084,
    width: 60.8761,
    height: 54.7885,
    rx: 11.5237,
    fill: "#87ABCA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35972,
    y: 9.90464,
    width: 61.9993,
    height: 55.1156,
    rx: 10.5634,
    stroke: "black",
    strokeWidth: 1.92061
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.399414,
    y1: 24.7965,
    x2: 64.3193,
    y2: 24.7965,
    stroke: "black",
    strokeWidth: 1.92061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2619 10.4648V2.95015C11.2619 2.38155 10.801 1.92061 10.2324 1.92061C9.66378 1.92061 9.20284 2.38155 9.20284 2.95015V10.4648H7.28223V2.95015C7.28223 1.32083 8.60305 0 10.2324 0C11.8617 0 13.1825 1.32083 13.1825 2.95015V10.4648H11.2619Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5168 10.4648V2.95015C55.5168 2.38155 55.0559 1.92061 54.4873 1.92061C53.9187 1.92061 53.4577 2.38155 53.4577 2.95015V10.4648H51.5371V2.95015C51.5371 1.32083 52.8579 0 54.4873 0C56.1166 0 57.4374 1.32083 57.4374 2.95015V10.4648H55.5168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f55e63f53def56c0482fe9987d9521d1.svg";
export { ForwardRef as ReactComponent };